// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"beh_a bhe_sl","StrollerBoxWidget__imageCounselling":"beh_b bhe_jz"};